﻿/**
 * replaces tags in the template with value from inputJson
 * @param {array|JSON} inputJson - array containing json
 * @param {string} template - HTML template
 */
const renderTemplate = (inputJson: Array<JSON>, template: string) =>
{
    var items = inputJson;
    var returnTemplate = template;

    // Loop through all keys
    if (Array.isArray(items))
    {
        items.forEach(function (keyItems, index)
        {
            // Get keys from first object
            var keys = Object.keys(keyItems);
            keys.forEach(function (item, index2)
            {
                //Check if value is arraylist or value
                if (Array.isArray(items[index][item]))
                {
                    var pattern = new RegExp("{foreach " + item + "}.*?{/foreach}");

                    if (typeof (pattern) !== typeof (undefined))
                    {
                        var result;
                        var replacement = '';
                        var orgTemplate = '';
                        while ((result = pattern.exec(returnTemplate)) !== null)
                        {
                            var templatebuilder = '';
                            replacement = result[0];
                            orgTemplate = replacement.replace(/([\/\,\!\\\^\$\{\}\[\]\(\)\.\*\+\?\|\<\>\-\&])/g, "\\$&");

                            replacement = replacement.replaceAll("{foreach " + item + "}", "");
                            replacement = replacement.replaceAll("{/foreach}", "");
                            var sectempl = replacement;
                            items[index][item].forEach(function (loopItem, loopIndex)
                            {
                                replacement = sectempl;
                                // Get keys from first object
                                var loopKeys = Object.keys(loopItem);
                                loopKeys.forEach(function (loopKeyItem)
                                {
                                    if (typeof (loopItem[loopKeyItem]) !== typeof (undefined))
                                        replacement = replacement.replaceAll("{" + loopKeyItem + "}", loopItem[loopKeyItem]);
                                    else
                                        replacement = replacement.replaceAll("{" + loopKeyItem + "}", "");
                                });
                                templatebuilder += replacement;
                            });

                            returnTemplate = returnTemplate.replaceAll(new RegExp(orgTemplate, "g"), templatebuilder);
                        }
                    }
                }
                else
                {
                    if (typeof (items[index]) !== typeof (undefined))
                        returnTemplate = returnTemplate.replaceAll("{" + item + "}", items[index][item]);
                    else
                        returnTemplate = returnTemplate.replaceAll("{" + item + "}", "");
                }
            });
        });
    }

    returnTemplate = returnTemplate.replaceAll("{staticDomain}", shopConfig !== null && typeof shopConfig !== 'undefined' ? shopConfig().staticDomain : "");
    returnTemplate = returnTemplate.replaceAll("{currentHost}", location.origin);
    return returnTemplate;
}

export { renderTemplate };
